import { Component, PropsWithChildren } from "react"

import { CustomErrorInfo, ErrorPage, ErrorPageProps } from "components/ErrorBoundary/ErrorPage"
import { SentryWrapper } from "utils/ThirdParty/Sentry/SentryWrapper"

interface State {
    hasError: boolean
    data: ErrorPageProps
}

export class ErrorBoundary extends Component<PropsWithChildren<void>, State> {
    constructor(props: PropsWithChildren<void>) {
        super(props)
        this.state = { hasError: false, data: {} }
    }
    static getDerivedStateFromError() {
        return {
            hasError: true,
        }
    }

    componentDidCatch(error: Error, errorInfo: CustomErrorInfo) {
        this.setState({
            data: {
                error,
                errorInfo,
            },
        })
        SentryWrapper.getInstance().captureException(error, {
            extra: errorInfo,
        })
    }

    render() {
        if (this.state.hasError) {
            return <ErrorPage {...this.state.data} />
        }

        return this.props.children
    }
}
